(() => {
  const key = 'hiblu-favorites-v1';
  const heart = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 8.5c0 4.2-8.8 10.2-8.8 10.2S3.2 12.7 3.2 8.5a4.7 4.7 0 0 1 8.8-2.1 4.7 4.7 0 0 1 8.8 2.1Z"/></svg>';
  let favorites = [];
  let storageAvailable = true;
  let returnFocus = null;

  const read = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(saved) ? saved.filter((item) => item && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0, 100) : [];
    } catch {
      storageAvailable = false;
      return [];
    }
  };
  favorites = read();

  const save = () => {
    try {
      localStorage.setItem(key, JSON.stringify(favorites));
      storageAvailable = true;
    } catch {
      storageAvailable = false;
    }
  };

  const productData = (element) => {
    const card = element.closest('product-card, .hiblu-home-card');
    const link = card?.querySelector('a.product-card__link[href*="/products/"], a[href*="/products/"]');
    const url = link && new URL(link.href, location.origin);
    if (!url || url.origin !== location.origin || !url.pathname.startsWith('/products/')) return null;
    const title = card.querySelector('h3, .hiblu-home-card__meta strong')?.textContent?.trim() || link.getAttribute('aria-label') || 'Product';
    const image = card.querySelector('.card-gallery img, .hiblu-home-card__image img, img.product-media__image')?.src || '';
    return { url: url.pathname, title, image };
  };

  const makeButton = (item, extraClass = '') => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `hiblu-favorite-button ${extraClass}`.trim();
    button.dataset.favoriteUrl = item.url;
    button.dataset.favoriteTitle = item.title;
    button.dataset.favoriteImage = item.image;
    button.innerHTML = heart;
    return button;
  };

  const dialog = document.createElement('dialog');
  dialog.className = 'hiblu-favorites-dialog';
  dialog.setAttribute('aria-labelledby', 'hiblu-favorites-title');
  dialog.innerHTML = '<div class="hiblu-favorites-panel"><div class="hiblu-favorites-head"><h2 id="hiblu-favorites-title">Favorites</h2><button type="button" class="hiblu-favorites-close" aria-label="Close favorites">×</button></div><p class="hiblu-favorites-note">Saved on this browser.</p><div class="hiblu-favorites-list"></div><p class="hiblu-favorites-status" role="status" aria-live="polite"></p></div>';
  const list = dialog.querySelector('.hiblu-favorites-list');
  const status = dialog.querySelector('.hiblu-favorites-status');

  const update = () => {
    document.querySelectorAll('.hiblu-favorite-button[data-favorite-url]').forEach((button) => {
      const selected = favorites.some((item) => item.url === button.dataset.favoriteUrl);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? 'Remove' : 'Add'} ${button.dataset.favoriteTitle} ${selected ? 'from' : 'to'} favorites`);
    });
    document.querySelectorAll('[data-hiblu-open-favorites]').forEach((button) => {
      button.setAttribute('aria-label', `Favorites, ${favorites.length} saved ${favorites.length === 1 ? 'product' : 'products'}`);
      const count = button.querySelector('.hiblu-favorites-count');
      count.textContent = favorites.length || '';
      count.hidden = favorites.length === 0;
    });
    list.replaceChildren();
    if (!favorites.length) {
      const empty = document.createElement('p');
      empty.className = 'hiblu-favorites-empty';
      empty.textContent = 'No favorites yet. Tap the heart on a product to save it here.';
      list.append(empty);
      return;
    }
    favorites.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'hiblu-favorites-item';
      const link = document.createElement('a');
      link.href = item.url;
      link.className = 'hiblu-favorites-product';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 72;
        image.height = 90;
        image.loading = 'lazy';
        link.append(image);
      }
      const title = document.createElement('span');
      title.textContent = item.title;
      link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'hiblu-favorites-remove';
      remove.dataset.removeFavorite = item.url;
      remove.setAttribute('aria-label', `Remove ${item.title} from favorites`);
      remove.textContent = 'Remove';
      row.append(link, remove);
      list.append(row);
    });
  };

  const addCardButtons = (root = document) => {
    root.querySelectorAll('product-card, .hiblu-home-card').forEach((card) => {
      if (card.querySelector('.hiblu-favorite-button')) return;
      const item = productData(card);
      if (!item) return;
      card.append(makeButton(item));
    });
  };

  const addProductButton = () => {
    if (!location.pathname.startsWith('/products/') || document.querySelector('.hiblu-favorite-button--product')) return;
    const title = document.querySelector('main h1');
    if (!title) return;
    const image = document.querySelector('main .product-media__image')?.src || '';
    const button = makeButton({ url: location.pathname, title: title.textContent.trim(), image }, 'hiblu-favorite-button--product');
    title.insertAdjacentElement('afterend', button);
  };

  const init = () => {
    const actions = document.querySelector('.hiblu-header__actions');
    if (actions && !actions.querySelector('[data-hiblu-open-favorites]')) {
      const open = document.createElement('button');
      open.type = 'button';
      open.className = 'hiblu-header__icon hiblu-favorites-open';
      open.dataset.hibluOpenFavorites = '';
      open.innerHTML = `${heart}<span class="hiblu-favorites-count" hidden></span>`;
      actions.insertBefore(open, actions.querySelector('.hiblu-header__account-component') || actions.querySelector('[data-hiblu-cart-link]'));
    }
    addCardButtons();
    addProductButton();
    update();
    document.body.append(dialog);
  };

  document.addEventListener('click', (event) => {
    const favorite = event.target.closest('.hiblu-favorite-button');
    if (favorite) {
      event.preventDefault();
      event.stopPropagation();
      const url = favorite.dataset.favoriteUrl;
      const index = favorites.findIndex((item) => item.url === url);
      if (index >= 0) favorites.splice(index, 1);
      else favorites.unshift({ url, title: favorite.dataset.favoriteTitle, image: favorite.dataset.favoriteImage });
      save();
      update();
      status.textContent = `${favorite.dataset.favoriteTitle} ${index >= 0 ? 'removed from' : 'added to'} favorites.${storageAvailable ? '' : ' Browser storage is unavailable, so this change will last only until you leave this page.'}`;
      return;
    }
    const open = event.target.closest('[data-hiblu-open-favorites]');
    if (open) {
      returnFocus = open;
      update();
      dialog.showModal();
      dialog.querySelector('.hiblu-favorites-close').focus();
      return;
    }
    const remove = event.target.closest('[data-remove-favorite]');
    if (remove) {
      favorites = favorites.filter((item) => item.url !== remove.dataset.removeFavorite);
      save();
      update();
      status.textContent = 'Product removed from favorites.';
      return;
    }
    if (event.target === dialog || event.target.closest('.hiblu-favorites-close')) dialog.close();
  }, true);
  dialog.addEventListener('close', () => returnFocus?.focus());
  window.addEventListener('storage', (event) => {
    if (event.key === key) { favorites = read(); update(); }
  });
  document.addEventListener('shopify:section:load', (event) => { addCardButtons(event.target); addProductButton(); update(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  let queued = false;
  new MutationObserver((records) => {
    if (queued || !records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('product-card, .hiblu-home-card') || node.querySelector?.('product-card, .hiblu-home-card'))))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; addCardButtons(); update(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
